import { ArrowRight } from "lucide-react";
import { Reveal } from "./motion";
import { CROSSOVER_FLOW } from "../lib/site";

export default function Crossover() {
  return (
    <section className="bg-mist" data-testid="crossover-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <Reveal className="max-w-3xl">
          <p className="font-mono text-[11px] tracking-[0.3em] text-steel mb-4">PROCUREMENT + OPERATIONS</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-navy leading-tight">
            One Partner. <span className="text-saffron">From Sourcing to Execution.</span>
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed max-w-2xl">
            Many businesses manage procurement and operations separately. Saarthva can connect the two —
            sourcing the product or vendor, coordinating delivery and then helping ensure the requirement
            is implemented and managed consistently.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-wrap items-center gap-2.5" data-testid="crossover-flow">
            {CROSSOVER_FLOW.map((step, i) => (
              <span key={step} className="flex items-center gap-2.5">
                <span className="rounded-full bg-navy text-white text-[13px] font-semibold px-4 py-2 whitespace-nowrap" data-testid={`crossover-step-${i}`}>
                  {step}
                </span>
                {i < CROSSOVER_FLOW.length - 1 && <ArrowRight className="w-4 h-4 text-saffron shrink-0" />}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
